import { FC } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

export interface CenteredMessageWithActionProps {
  /** Main heading text */
  title: string;
  /** Supporting description text */
  description: string;
  /** Label for the action button */
  buttonText: string;
  /** Called when the action button is clicked */
  onButtonClick: () => void;
}

/**
 * Centered message block with a title, description, and single action button.
 * Useful for error states (e.g. 404), empty states, or other "unexpected" UI cases.
 */
export const CenteredMessageWithAction: FC<CenteredMessageWithActionProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 0,
      }}
    >
      <Typography
        variant='h4'
        sx={{
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>

      <Typography
        variant='body1'
        sx={{
          color: 'text.secondary',
          mb: 3,
        }}
      >
        {description}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <Button
          variant='contained'
          startIcon={<ArrowBack />}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  </Box>
);
